import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as api from './utils/api'
import {
  Icon
} from 'vant';
import {
  Lazyload,
  Image as VanImage,
  Switch,
  ImagePreview,
  Toast
} from 'vant';
import {
  SOHERF
} from './utils/tool';
import store from './store'
import 'vant/lib/index.less';

import VueLazyLoad from 'vue-lazyload'

let socket = null;
Vue.use(VueLazyLoad, {
  error: require('./assets/close.png'),
  loading: require('./assets/close.png'),
})


Vue.prototype.api = api;
Vue.prototype.imagePreview = ImagePreview;
Vue.prototype.Toast = Toast;
// Vue.prototype.connectws = connectws;
Vue.prototype.socket = socket;

var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?6a58e29cfb3b90e10d2a121ea87052a0";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();

Vue.use(Icon);
Vue.use(Lazyload);
Vue.use(VanImage);
Vue.use(Switch);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')